import React, { useEffect, useState } from 'react';

const Alert = ({ children, setShowAlert, success = true, loggedIn = false, dialog = false }) => {
  return (
    <>
      <div
        className={` ${
          loggedIn ? (dialog ? 'absolute' : 'absolute sm:sticky') : 'fixed lg:w-1/2 w-full'
        }  bottom-0 left-0 right-0 ${
          success ? 'bg-green-light' : 'bg-red'
        } z-[1000] px-14 py-8 text-center animate-messageToggleOpen`}>
        {children}
        <button
          onClick={() => setShowAlert(false)}
          className="absolute top-2.5 right-2.5 text-xs md:text-base">
          <span className="h-7 w-7 md:h-10 md:w-10 flex justify-center items-center border-none text-sm">
            X
          </span>
        </button>
      </div>
    </>
  );
};

export default Alert;
